import React from 'react';
// material
import { Button, Card, CardContent, Grid, withStyles} from '@material-ui/core';
//styles
import styles from './avatar-card-styles';
// components
import Avatar from '../../avatar';

const AvatarCardView = (props) => {
  const {classes, toggleEdit, isLoading, photoUrl} = props;

  return (
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item>Avatar</Grid>
          <Grid item>
            <Button
              color={'primary'}
              size={'small'}
              variant={'contained'}
              onClick={toggleEdit}>
              Edit
            </Button>
          </Grid>
        </Grid>
        {
          !isLoading &&
          <Grid container className={classes.displayBody} spacing={2}>
            <Grid item xs={12}>
              <Grid container direction='column' justify='center' alignItems='center'>
                <Avatar src={photoUrl} alt={'photo'} size={250} />
              </Grid>
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (AvatarCardView);